









    
import {Vue, Component} from 'vue-property-decorator';
import { Quote, QuoteService } from '../../services/accounting.service';
import QuoteList from './List.vue'

@Component({
    components: {
        QuoteList,
    }
})
export default class QuotesIndex extends Vue {

    formOpen = false;

    api: QuoteService = new QuoteService();
    quotes: Quote[] = [];
    loading = false;
    initialized = false;

    cancelEdit() {
        this.formOpen = false;
    }

    async created() {
        await this.refresh();
        this.initialized = true;
    }

    async mounted() {
        await this.refresh();
    }

    async refresh() {
        this.loading = true;
        const res = await this.api.get();
        if (res.success === true) this.quotes = res.result;
        this.loading = false;
        console.log(this.quotes);
    }

    async create() {
        
    }

    async remove(quote: Quote) {
        await this.api.delete(quote.id);
        await this.refresh();
    }

    async invoice(quote: Quote) {
        await this.api.convert(quote);
        await this.refresh();
    }

    view(quote: Quote) {
        this.$router.push({name: 'Quote', params: {id: quote.id}});
    }
}

